import React from 'react';
import { Button, notification } from 'antd';
import { SmileOutlined } from '@ant-design/icons';



export const useNotification = () => {
    const [api, contextHolder] = notification.useNotification();

    const openNotification = (placement) => {
        const key = `notification-${Date.now()}`; // Уникальный ключ для уведомления

        api.info({
            key, // Уникальный ключ для управления уведомлением
            message: 'Уведомления',
            description: 'Согласны ли вы на получение уведомлений?',
            placement,
            icon: (
                <SmileOutlined
                    style={{
                        color: ' #B10000',
                    }}
                />
            ),
            duration: 0, // Уведомление не закроется автоматически
            btn: (
                <div>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                            api.destroy(key); // Закрыть уведомление
                            console.log('Пользователь подтвердил получение уведомлений');
                        }}
                        style={{fontWeight: 'bold'}}
                    >
                        Подтвердить
                    </Button>
                    <Button
                        type="default"
                        size="small"
                        onClick={() => {
                            api.destroy(key); // Закрыть уведомление
                            console.log('Пользователь отклонил уведомления');
                        }}
                        style={{ marginLeft: 8 }}
                    >
                        Закрыть
                    </Button>
                </div>
            ),
        });
    };

    return { openNotification, contextHolder };
};